/* Light YouTube Embeds by @labnol */
/* Web: http://labnol.org/?p=27941 */

export default function () {
  function labnolThumb(id) {
    return `<img src="https://i.ytimg.com/vi/${id}/hqdefault.jpg"><div class="play"></div>`
  }

  function labnolIframe() {
    const iframe = document.createElement('iframe');
    const embed = 'https://www.youtube.com/embed/ID?autoplay=1';
    iframe.setAttribute('src', embed.replace('ID', this.dataset.id));
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '1');
    this.parentNode.replaceChild(iframe, this);
  }

  document.addEventListener("turbo:load",
    () => {
      let div; let n;
      const v = document.getElementsByClassName('youtube-player');
      for (n = 0; n < v.length; n += 1) {
        div = document.createElement('div');
        div.setAttribute('data-id', v[n].dataset.id);
        div.innerHTML = labnolThumb(v[n].dataset.id);
        div.onclick = labnolIframe;
        v[n].appendChild(div);
      }
    });
}
